'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileListView;

var _preact = require('preact');

var _format = require('../../../vendor/format.js');

var _format2 = _interopRequireDefault(_format);

var _FileUploadButton = require('./FileUploadButton.jsx');

var _FileUploadButton2 = _interopRequireDefault(_FileUploadButton);

var _fileLink = require('../../../containers/fileLink.js');

var _fileLink2 = _interopRequireDefault(_fileLink);

var _taskContentLink = require('../../../containers/taskContentLink.js');

var _taskContentLink2 = _interopRequireDefault(_taskContentLink);

var _taskStyleLink = require('../../../containers/taskStyleLink.js');

var _taskStyleLink2 = _interopRequireDefault(_taskStyleLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FileListView(props) {
  var file_list = void 0;
  if (props.folder && props.folder.files) {
    file_list = props.folder.files;
  } else {
    file_list = [];
  }
  var files = file_list.map(toFilenamePair).sort(sortByFilename).map(fromPair).map(function (file, i) {
    if (!file) return;
    return (0, _preact.h)(
      'div',
      { key: i, 'class': props.selected === file ? 'selected' : '' },
      (0, _preact.h)(
        'span',
        { 'class': 'name' },
        (0, _preact.h)(
          _fileLink2.default,
          { file: file },
          file.name
        )
      ),
      (0, _preact.h)(
        'span',
        { 'class': 'mime' },
        file.processed ? _format2.default.getAge(file.created_at) : '(waiting)'
      ),
      (0, _preact.h)(
        'span',
        { 'class': 'duration' },
        file.duration ? file.duration.toFixed(1) + 's' : ''
      ),
      (0, _preact.h)(
        'span',
        { 'class': 'actions' },
        (0, _preact.h)(
          _taskContentLink2.default,
          { file: file },
          'content'
        ),
        (0, _preact.h)(
          _taskStyleLink2.default,
          { file: file },
          'style'
        )
      )
    );
  });
  return (0, _preact.h)(
    'div',
    { 'class': 'window' },
    (0, _preact.h)(
      'div',
      { 'class': 'heading' },
      (0, _preact.h)(
        'b',
        null,
        props.folder.name
      ),
      (0, _preact.h)(
        'div',
        { 'class': 'buttons' },
        (0, _preact.h)(_FileUploadButton2.default, { folder: props.folder, addFiles: props.addFiles }),
        (0, _preact.h)(
          'button',
          { onClick: props.onClose },
          '\xD7'
        )
      )
    ),
    (0, _preact.h)(
      'div',
      { 'class': 'files list' },
      files
    )
  );
}

function toFilenamePair(file) {
  return [file.name.toLowerCase(), file];
}
function sortByFilename(a, b) {
  return a[0] < b[0] ? -1 : a[0] == b[0] ? 0 : 1;
}
function fromPair(pair) {
  return pair[1];
}

function filepath(file) {
  return '/data/' + file.folder_id + '/' + encodeURIComponent(file.name);
}
function mp3path(file) {
  if (file.mime !== 'audio/mp3') {
    return filepath(file) + '.mp3';
  }
  return filepath(file);
}
function pngpath(file) {
  return filepath(file) + '.png';
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Browser/Files/FileListView.jsx
// module id = 79
// module chunks = 0